<template>
  <el-group-title title="其他费用" class="ccui-group-wrapper">
    <template slot="groupTitle">
      <el-form
        :model="form"
        label-width="100px"
        class="ccui-form"
        style="overflow:visible;"
      >
        <div class="extend-btn">
          <el-button plain type="single-number" @click="addTable">
            新增
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="projectCode"
            label="项目编码"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.projectCode"
                placeholder="请输入项目编码"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="projectName"
            label="项目名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.projectName"
                placeholder="请输入项目名称"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="count"
            label="数量"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.count"
                placeholder="请输入数量"
                clearable
                maxlength="3"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="measuringUnit"
            label="计量单位"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.measuringUnit"
                placeholder="请输入计量单位"
                clearable
                maxlength="2"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="totalAmtExcludeTax"
            label="不含税合价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.totalAmtExcludeTax"
                placeholder="请输入不含税合价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceExcludingTax"
            label="不含税单价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.unitPriceExcludingTax"
                placeholder="请输入不含税单价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceIncludingTax"
            label="含税单价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.unitPriceIncludingTax"
                placeholder="请输入含税单价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="totalAmtIncludeTax"
            label="含税金额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.totalAmtIncludeTax"
                placeholder="请输入含税金额"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="tax"
            label="含税税额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.tax"
                placeholder="请输入含税税额"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="taxRate"
            label="税率"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.taxRate"
                placeholder="请输入税率"
                clearable
                maxlength="4"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "materialsManagementInventory",
  props: {
    responsibility: {
      type: String,
      default: ""
    },
    taxRate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [{ id: "1" }],
      form: {}
    };
  },
  methods: {
    // 新增
    addTable() {
      this.tableData.push({
        id: this.tableData.length + 1
      });
    },
    // 删除
    delTable(index, row) {
      this.tableData.splice(index, 1);
    }
  }
};
</script>
